import React from 'react'
import { graphql } from 'gatsby'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'
import PageHelmet from 'src/components/PageHelmet'
import AboutPage from 'src/components/AboutPage'

const About = (props) => {
  const {
    data: {
      allMarkdownRemark: {
        edges: [node],
      },
    },
    pageContext: { locale },
  } = props
  return (
    <>
      <PageHelmet title="О проекте" locale={locale} />
      <Header full={true} locale={locale} />
      <AboutPage data={node} locale={locale} />
      <Footer locale={locale} />
    </>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "About" } } }) {
      edges {
        node {
          html
          frontmatter {
            title
          }
        }
      }
    }
  }
`

export default About
